<template>
  <div id="OrganizationSelectModal">
    <div class="modal-card" style="width:900px;">
      <header class="modal-card-head">
        <p class="modal-card-title" style="color: whitesmoke;">{{title}}</p>
      </header>
      <section class="modal-card-body">
        <!--検索条件 -->
        <div class="condition-area">
          <table class="conditionTable">
            <template v-if="!transferFlg && !isCpapAgentReqFlg">
            <tr>
              <th>組織ID</th><td><input type="text" :disabled="sstId!=''" v-model="orgId" maxlength="10"/></td>
              <th>得意先コード</th><td><input type="text" v-model="customerCode"/></td>
              <th>{{labelForOrg}}</th><td><input type="text" v-model="orgName" maxlength="256"/></td>
            </tr>
            </template>
            <template v-else-if="transferFlg && !isCpapAgentReqFlg">
              <tr>
                <th>{{labelForOrg}}</th><td><input type="text" v-model="orgName" maxlength="256"/></td>
                <th>都道府県<span class="require"/></th>
                <td>
                  <select v-model="prefecture" name="都道府県">
                    <option value=""/><option value="北海道">北海道</option><option value="青森県">青森県</option><option value="岩手県">岩手県</option><option value="宮城県">宮城県</option><option value="秋田県">秋田県</option><option value="山形県">山形県</option><option value="福島県">福島県</option><option value="茨城県">茨城県</option><option value="栃木県">栃木県</option><option value="群馬県">群馬県</option><option value="埼玉県">埼玉県</option><option value="千葉県">千葉県</option><option value="東京都">東京都</option><option value="神奈川県">神奈川県</option><option value="新潟県">新潟県</option><option value="富山県">富山県</option><option value="石川県">石川県</option><option value="福井県">福井県</option><option value="山梨県">山梨県</option><option value="長野県">長野県</option><option value="岐阜県">岐阜県</option><option value="静岡県">静岡県</option><option value="愛知県">愛知県</option><option value="三重県">三重県</option><option value="滋賀県">滋賀県</option><option value="京都府">京都府</option><option value="大阪府">大阪府</option><option value="兵庫県">兵庫県</option><option value="奈良県">奈良県</option><option value="和歌山県">和歌山県</option><option value="鳥取県">鳥取県</option><option value="島根県">島根県</option><option value="岡山県">岡山県</option><option value="広島県">広島県</option><option value="山口県">山口県</option><option value="徳島県">徳島県</option><option value="香川県">香川県</option><option value="愛媛県">愛媛県</option><option value="高知県">高知県</option><option value="福岡県">福岡県</option><option value="佐賀県">佐賀県</option><option value="長崎県">長崎県</option><option value="熊本県">熊本県</option><option value="大分県">大分県</option><option value="宮崎県">宮崎県</option><option value="鹿児島県">鹿児島県</option><option value="沖縄県">沖縄県</option>
                  </select>
                </td>
              </tr>
              <tr>
                <th>得意先コード</th><td><input type="text" v-model="customerCode"/></td>
                <th>営業所</th>
                <td>
                  <select v-model="salesOfficeCode">
                    <option v-for="item in salesOfficeMaster" :key="item.code" :value="item.code">{{item.name}}</option>
                  </select>
                </td>
              </tr>
              <tr>
                <th>組織ID</th><td><input type="text" :disabled="sstId!=''" v-model="orgId" maxlength="10"/></td>
                <!-- 施設ID追加20231005 -->
                <th  v-if="transferFlg">施設ID</th><td><input type="text" :disabled="orgId!=''"  v-model="sstId" maxlength="10" /></td>
              </tr>
            </template>
            <template v-else-if="isCpapAgentReqFlg">
             <tr>
              <th>担当営業所<span class="require"/></th>
              <td>
              <select v-model="salesOfficeCode">
                <option v-for="item in salesOfficeMaster" :key="item.code" :value="item.code">{{item.name}}</option>
              </select>
              </td>
              <!-- 施設ID追加20231005 -->
              <th>組織ID</th><td><input type="text" :disabled="sstId!=''" v-model="orgId" maxlength="10"/></td>
            </tr>
            <tr>
              <th>得意先コード</th><td><input type="text" v-model="customerCode"/></td>
              <th>{{labelForOrg}}</th><td><input type="text" v-model="orgName" maxlength="256"/></td>
            </tr>
            </template>
            <template v-if="canSelect">
              <tr>
                <th>種別</th>
                <td>
                  <select id="SelcectRole" v-model="selectedRole">
                    <option value=""></option>
                    <option v-if="canSelectRole(role.role_hospital)" :value="role.role_hospital">医療機関</option>
                    <option v-if="canSelectRole(role.role_corporation)" :value="role.role_corporation">企業</option>
                    <option v-if="canSelectRole(role.role_judgment)" :value="role.role_judgment">判定医療機関</option>
                    <option v-if="canSelectRole(role.role_holter_judgment)" :value="role.role_holter_judgment">ホルター判定医</option>
                    <option v-if="canSelectRole(role.role_analysis)" :value="role.role_analysis">解析委託業者</option>
                    <option v-if="canSelectRole(role.role_dealer)" :value="role.role_dealer">ディーラー</option>
                    <option v-if="canSelectRole(role.role_accommodations)" :value="role.role_accommodations">宿泊施設</option>
                  </select>
                </td>
              </tr>
            </template>
            <template v-if="cpapUsedList">
              <tr>
                <!-- <th>使用明細を支店から発行（FAX・持参等）する施設のみ検索する</th> -->
                <td colspan="6">
                  <b-checkbox class="cstmCheckBox" v-model="cpapUsageDetailBehalfNot">使用明細を支店から発行（FAX・持参等）しない施設のみ検索する</b-checkbox>
                </td>
              </tr>
            </template>
          </table>
          <div class="searchButton-area" style="margin-bottom:10px;text-align: center;">
            <b-button class="is-primary" @click="doSearch">検索</b-button>
          </div>
        </div>
        <!-- 検索結果 -->
        <div class="result-area">
          <b-table
            v-if="data.length > 0"
            id="customerSelectTable"
            :data="data"
            paginated
            per-page="20"
            pagination-position="both"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page"
          >
            <template slot-scope="props">
              <b-table-column field="customerId" label="" width="20" centered>
                <b-radio class="customRadio" name="radioItem" v-model="selectedItem" :native-value="props.row"></b-radio>
              </b-table-column>
              <b-table-column field="id" label="組織ID" width="70" centered>{{props.row.id }}</b-table-column>
              <!-- 施設ID追加20231005 -->
              <b-table-column v-if="transferFlg" field="sstId" label="施設ID" width="70" centered>{{props.row.sstId }}</b-table-column>
              <b-table-column field="customerCode" label="得意先コード" width="150" centered>{{props.row.customerCode }}</b-table-column>
              <b-table-column field="name" :label="labelForOrg" width="300" >{{props.row.orgName}}</b-table-column>
              <b-table-column v-if="!isDealer && !isHospital" field="actor" label="種別" width="300" >{{props.row.roleName}}</b-table-column>             
              <b-table-column v-if="transferFlg" field="salesOfficeName" label="営業所" width="150" >{{props.row.salesOfficeCode | officeFilter(salesOfficeMaster)}}</b-table-column>  
              <b-table-column field="address" label="住所" width="500" >{{props.row.prefecture}}{{props.row.city}}{{props.row.address}}{{props.row.building}}</b-table-column>
            </template>
          </b-table>
        </div>
      </section>
      <footer class="modal-card-foot">
        <button class="button" type="button" @click="save" :disabled="!selectedItem">決定</button>
        <button class="button" type="button" @click="$parent.close()">閉じる</button>
      </footer>
    </div>
  </div>
</template>
<script>
import {role} from "@/components/mock/base/const.js";
export default {
  name: "OrganizationSelectModal",
  props: {
    title:{default:"組織選択"},
    labelForOrg:{default:"組織名"},
    selectRole:{type:[Array], default: () => [], },
    transferFlg: {default: false},
    canSelect: {default: false},
    selectStatus: {default: ""},
    exclusionId:null,
    agreedInfoDisclosure:false,
    serviceId: null,
    cpapUsedList: {default: false},
    holterdepositFlag: {default: false},
    cpapAgentReqFlg:false,
    cpapDepositUseFlg:{default: false},
  },
  methods: {
    save: function() {
      this.$emit('select', this.selectedItem);
      this.$parent.close();
    },
    doSearch: function() {
      let _this = this;
      let roleList = [];
      if(!this.selectedRole){
         roleList = this.selectRole;
      } else {
        roleList.push(this.selectedRole)
      }
      if(_this.isCpapAgentReqFlg && !_this.salesOfficeCode){
        // 担当営業所が選択されていない場合
        this.showErrorMessage("担当営業所が入力されていません。")
        return;
      }
      if(_this.transferFlg && !_this.isCpapAgentReqFlg && !_this.prefecture){
        // 都道府県が選択されていない場合
        this.showErrorMessage("都道府県が入力されていません。")
        return;
      }
      // Web Api Call
      this.apiCall(
        function(client){
          return client.apis.apiCommon.getOrganizationListPOST({
            body:{
              orgId: _this.orgId,
              // 施設ID追加20231005
              sstId: _this.sstId,
              transferFlg:_this.transferFlg,
              customerCode:_this.customerCode,
              orgName:_this.orgName,
              roleList:roleList,
              status: _this.selectStatus,
              agreedInfoDisclosure:_this.agreedInfoDisclosure,
              cpapUsageDetailBehalfNot:_this.cpapUsageDetailBehalfNot,
              serviceId: _this.serviceId,
              holterdepositFlag: _this.holterdepositFlag,
              salesOfficeCode:_this.salesOfficeCode,
              cpapDepositUseFlg: _this.cpapDepositUseFlg,
              prefecture: _this.prefecture,
            }
          });
        },
        function(result) {
          // 検索結果取得
          _this.data = result.obj
          if(_this.exclusionId){
            // 検索結果から除外対象を除く
            _this.data = _this.data.filter(val => val.id != _this.exclusionId)
          }
        },
        function(result) {
          // エラーメッセージ表示
          _this.showErrorMessage(result);
        },
      );
    },
    canSelectRole: function(selectValue) {
      var ret = true;
      if(this.selectRole){
        ret = this.selectRole.indexOf(selectValue) > -1;
      }
      return ret;
    },
    initialize() {
      let _this = this;
      if(_this.cpapAgentReqFlg){
        _this.isCpapAgentReqFlg = _this.cpapAgentReqFlg;
        _this.salesOfficeCode = _this.isUserInfo.salesOfficeCode;
      }
    }
  },
  data() {
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var roleId = userInfo.roleId
    var isHospital = roleId == role.role_hospital;
    var isDealer = roleId == role.role_dealer;
    let salesOfficeMaster = this.getSalesOfficeMaster();
    salesOfficeMaster.unshift({});
    return {
      role: role,
      data: [],
      orgId: "",
      sstId: "",
      customerCode:"",
      orgName:"",
      selectedRole:"",
      selectedItem:'',
      cpapUsageDetailBehalfNot:false,
      isHospital:isHospital,
      isDealer:isDealer,
      isUserInfo:userInfo,
      isCpapAgentReqFlg:false,
      salesOfficeMaster,
      salesOfficeCode:""
    };
  },
  filters: {
    officeFilter(value,officeList){
      var target = officeList.find(val => val.code == value)
      if(target){
        return target.name
      }
      return ""
    },
  },
  components: {},
  mounted: function () {
    this.initialize();
  },
};
</script>
<style lang="scss" scoped>
.customRadio {
  width:10px;
}
.result-area {
  height: 450px;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/common/OrganizationSelectModal.vue